<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="1"/>
    <circle cx="12" cy="19" r="1"/>
    <circle cx="12" cy="5" r="1"/>
  </svg>
</template>
